import CommonImageModal from 'components/common/commonImageModal'
import React from 'react'

function Map({images}) {
    return (
        <div className="gallery">
            <ul className="gallery-list">
                {
                    images.map(item=>{
                        return(
                            <li key={item.UserFileName} className="gallery-list__item">
                                <div className="gallery-list__item-image">
                                    <CommonImageModal src={'/'+item.FileLocation}  alt={"Route Image"} />
                                    {/* <img src={'/'+item.FileLocation} alt="Route Image"/> */}
                                </div>
                            </li>
                        )
                    })
                }
            </ul>
        </div>
    )
}

export default Map
